import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	createWithAIItem: {
		id: 'jira-ai.create-with-ai.create-with-ai-item',
		defaultMessage: 'Create with AI',
		description: 'The text for the create with AI item in the dropdown',
	},
});
